"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const PredictionItemCustom = ({ htmlId, activeIndex, idx, prediction, activeOptionRef, onOptionClick, onOptionMouseDown, customLocationIcon }) => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.default)({
            "option-current": activeIndex === idx,
            "autocomplete-option": true,
        }), id: `${htmlId}-${idx}`, "aria-selected": false, ref: (el) => {
            if (activeIndex === idx) {
                activeOptionRef.current = el;
            }
        }, role: "option", onClick: () => {
            onOptionClick(idx);
        }, onMouseDown: () => {
            onOptionMouseDown(idx);
        } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: customLocationIcon, className: "ontario-house-icon", alt: "" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "name" }, { children: (() => {
                            var _a, _b, _c;
                            const matches = prediction.matched_substrings.sort((a, b) => a.offset - b.offset === 0
                                ? b.length - a.length
                                : a.offset - b.offset), displayJSX = [];
                            let currentOffset = 0;
                            for (const { offset, length } of matches) {
                                if (offset < currentOffset) {
                                    continue;
                                }
                                displayJSX.push((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: ((_a = prediction.name) !== null && _a !== void 0 ? _a : "").substring(currentOffset, offset) }, displayJSX.length));
                                displayJSX.push((0, jsx_runtime_1.jsx)("strong", { children: ((_b = prediction.name) !== null && _b !== void 0 ? _b : "").substring(offset, offset + length) }, displayJSX.length));
                                currentOffset = offset + length;
                            }
                            displayJSX.push((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: ((_c = prediction.name) !== null && _c !== void 0 ? _c : "").substring(currentOffset) }, displayJSX.length));
                            return displayJSX;
                        })() })), prediction.address && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "address" }, { children: prediction.address })))] })] }), prediction.url_en));
};
exports.default = PredictionItemCustom;
